import type { StudioJob } from '@/features/ai/studioTypes'
import { failedReasonText } from '@/features/ai/lib/failedReasonText'
import type { Outcome } from './runOutcomeView'
import { messagesNow } from '@/i18n'
import { messages } from './sidebarMessages'

/**
 * Единственный текст студии, который НЕ пришёл с сервера.
 *
 * Отступление сознательное: картиночный прогон идёт через n8n, а там отказ
 * модели никуда не записывается — `record_skip` на этом пути не вызывается
 * (api/src/api/routers/n8n_image_callbacks.py). Автор видел «Нарисовано 0 из 9»
 * без единого слова о том, что случилось.
 *
 * Причин нуля штатно ТРИ (docs/studio-ai-api.md §4): промпт у цели исчез до
 * старта, модель отказалась рисовать, у слота не открылся референс базовой
 * картинки. Поэтому текст перечисляет, а не ставит диагноз: назвав одну,
 * он отправлял бы автора чинить не то.
 *
 * Только для картиночного прогона. У остальных типов тариф по токенам
 * (`studio_pricing.py`), и сожжённые списываются даже при нулевом
 * результате — обещание «кредиты не списаны» там было бы враньём про деньги.
 */
export const emptyRunReason = (): string => messagesNow(messages).emptyRunReason

/** Русская редакция того же текста — эталон для тестов (они идут на русском). */
export const EMPTY_RUN_REASON = messages.ru.emptyRunReason

/**
 * Текст под заголовком исхода. Серверная причина всегда главнее своей: на
 * `failed` показываем то, что прислал сервер, переведя известный код через
 * `failedReasonText` (общая таблица со снимком продолжения, который в реестр
 * кладёт `useResumeJob`, §8) — и только молчаливый нулевой прогон объясняем
 * сами.
 */
export const outcomeReason = (
  job: StudioJob,
  outcome: Outcome,
  hasSkips: boolean,
): string | null => {
  if (job.status === 'failed') {
    return failedReasonText(job.error_code, job.error_message)
  }
  // Сервер назвал причины поимённо — свой текст стал бы вторым, более общим
  // объяснением того же самого.
  if (job.type === 'course_image_generation' && outcome === 'empty' && !hasSkips) {
    return emptyRunReason()
  }
  return null
}
